export function updateFrequency(frequency){

    const path = "/api/v1/update-frequency/";
    const options = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ frequency: frequency })
    };    
    return fetch(`${path}`, options)     
    .then(response => {
      if (response.status !== 200) {       
        throw Error(response.statusText);
      }
      return response;
    })
    .then(response => response.json())
}

export function getPriceByQuoteParameters(quoteParameters){

  const path = "/api/v1/quote/";

  return fetch(`${path}`, {
    body: JSON.stringify(quoteParameters),
    method: 'POST',
    headers: {    
      'Content-Type': 'application/json'      
    }
  })     
  .then(response => {
    if (response.status !== 200) {       
      throw Error(response.statusText);
    }
    return response;
  })
  .then(response => response.json())
}